let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;

if (!env) {
	console.error('ENV: ', env);
	env = 'development';
}

let gameUrl = 'localhost:3000';
let apiURL = 'http://localhost:8080/api/';
let gamesDbName = 'games';
let groupsDbName = 'groups';
let adminsDbName = 'admins';
let statsDbName = 'statistics';
if (env === 'test' || env === 'demo') {
	gameUrl = 'cgl-diipta-test.web.app';
	apiURL = 'https://cgl-diipta-test.web.app/api/';
	if (env === 'demo') {
		gamesDbName = 'games-demo';
		groupsDbName = 'groups-demo';
		statsDbName = 'statistics-demo';
		gameUrl = 'cgl-diipta-demo.web.app';
		apiURL = 'https://cgl-diipta-demo.web.app/api/';
	}
}
if (env === 'production') {
	gameUrl = 'holdspillet.dk';
	apiURL = 'https://cgl-diipta-production.web.app/api/';
}
 
const appConfig = {
	env: env,
	showDevTools: (env === 'development' || env === 'test'),
	gamesDbName,
	groupsDbName,
	adminsDbName,
	statsDbName,
	apiURL: apiURL,
	gameUrl: gameUrl,
	cookieConsentCookieName: 'diipta_cookie-consent-data',
	groupNameMinLength: 3,
	groupNameMaxLength: 15
};

export default appConfig;
